import type { InfoLinkCardProp, InfoLinkCardsProps } from '/site/parts/info-link-cards/info-link-cards.d';

import React from 'react';
import { Link } from '@hdir/ui/link';
import { LinkIcon } from './LinkIcon';

export function InfoLinkCards(props: InfoLinkCardsProps): JSX.Element {
	const {
		cards,
	} = props;

	const InfoCard: React.FC<InfoLinkCardProp> = (card: InfoLinkCardProp) => {
		return (
			<Link
				className="!p-md tablet:!p-xl flex !flex-row !items-center !gap-md tablet:!gap-xl border-sm rounded-md border-gray-400 !w-full"
				href={card.link?.href}
				variant="card"
			>
				<picture className="flex flex-shrink-0 items-center h-full">
					<img src={card.icon} alt="" className="w-12 h-full"/>
				</picture>
				<header className="flex flex-row justify-between items-center gap-xl flex-grow">
					<h3 className="font-bold text-xxl text-balance leading-normal">
						{card.title}
						{card.link?.hostname ? ` (${card.link.hostname})` : null}
					</h3>
					<LinkIcon
						className='w-5 h-5 shrink-0 color-icon-action-default'
						link={card.link}
					/>
				</header>
			</Link>
		);
	};

	return (
		<section>
			<div className="grid grid-cols-1 desktop:grid-cols-2 auto-cols-min gap-md tablet:gap-xl place-content-center max-w-content mx-auto">
				{cards.map((card, index) => (
					<InfoCard key={index} {...card} />
				))}
			</div>
		</section>
	);
}
